// removed by extract-text-webpack-plugin
module.exports = {"grid":"_1DoJFOxy5 _3lHRe10pm","grid-body":"_3zJ-AYjeC _17qxy1jyE"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/grid/grid.css
 ** module id = 2133
 ** module chunks = 0
 **/